export default (values) => {
  let errors = {}

  if (!values.username) {
    errors.username = 'Forneça seu nome de usuário!'
  }

  if (!values.password) {
    errors.password = 'Forneça uma senha!'
  }

  return errors
}
